import { render, staticRenderFns } from "./RessourceInfoBulle.vue?vue&type=template&id=2318f5be"
import script from "./RessourceInfoBulle.vue?vue&type=script&lang=js"
export * from "./RessourceInfoBulle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports